import type { ReactNode } from 'react'
import { MapPipelineDisclaimer } from './MapPipelineDisclaimer'

export type MapSurfaceVariant = 'fluid' | 'default'

type MapSurfaceProps = {
  children: ReactNode
  /** `fluid` fills available main content height and reserves space for the disclaimer. */
  variant?: MapSurfaceVariant
  className?: string
}

/**
 * Wraps a `Map` (or other map host) with the pipeline disclaimer directly underneath.
 * Use `variant="fluid"` for map-primary screens (Home explorer, operator overview, etc.).
 */
export function MapSurface({ children, variant = 'default', className }: MapSurfaceProps) {
  const rootClass = [
    'map-surface',
    variant === 'fluid' ? 'map-surface--fluid' : '',
    className ?? '',
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <div className={rootClass}>
      <div className="map-surface-map">{children}</div>
      <MapPipelineDisclaimer />
    </div>
  )
}
